var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white p-3 rounded-md bg-black bg-opacity-20 whitespace-pre-wrap text-left"},[_vm._v(" "+_vm._s(_vm.messageData.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }